import React from 'react';
import { Link } from 'react-router-dom';

// Tailwind needs literal class names at build time — no template interpolation.
const SPAN = {
  2: 'md:col-span-2',
  3: 'md:col-span-3',
  4: 'md:col-span-4',
  6: 'md:col-span-6',
};

const BentoCard = ({ span = 2, dark = false, label, title, desc, href, className = '' }) => {
  const surface = dark
    ? 'bg-navy'
    : 'bg-white border border-line';
  const labelColor = dark ? 'text-bluegray-muted' : 'text-accent';
  const titleColor = dark ? 'text-white' : 'text-navy';
  const descColor = dark ? 'text-bluegray-soft' : 'text-slate';

  const body = (
    <>
      {label && (
        <p className={`${labelColor} text-[10px] tracking-widest uppercase`}>
          {label}
        </p>
      )}
      <h3 className={`${titleColor} text-lg font-medium mt-2`}>{title}</h3>
      {desc && (
        <p className={`${descColor} text-sm mt-1 leading-relaxed`}>{desc}</p>
      )}
    </>
  );

  const classes = `col-span-6 ${SPAN[span] || SPAN[2]} ${surface} rounded-tile p-5 block ${className}`;

  if (href) {
    return (
      <Link to={href} className={classes}>
        {body}
      </Link>
    );
  }
  return <div className={classes}>{body}</div>;
};

export default BentoCard;
